import React, { useMemo, memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ClockIcon from 'assets/icons/clock.png'

function MachineInstallingQuarters({ className, from, to }) {
  const { t } = useTranslation()

  const text = `${to - from + 1} ${t('general.quarters')}`
  const progress = useMemo(() => `${Math.trunc((from / to) * 100)}%`, [from, to])

  return (
    <div className={`machine-installing-quarters ${className}`}>
      <div className="machine-installing-quarters__text">{text}</div>
      <div className="machine-installing-quarters__progress" style={{ width: progress }} />
      <img src={ClockIcon} alt="quarters clock" className="machine-installing-quarters__clock" />
    </div>
  )
}

MachineInstallingQuarters.propTypes = {
  className: PropTypes.string,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired
}

MachineInstallingQuarters.defaultProps = {
  className: ''
}

export default memo(MachineInstallingQuarters)
